document.addEventListener('DOMContentLoaded', function () {

  fwLog('Seite geladen - Start der Überprüfungen');
  fwLog('JavaScript Logging aktiviert:', window.loggingEnabled);

/*   fwLog('Maximale Bestellmenge von Liquid:', window.maxOrderQuantity);


  const maxOrderQuantity = window.maxOrderQuantity; */


  function getProductPrice() {
    const priceElement = document.querySelector('.price__current');
    if (priceElement) {
      const priceText = priceElement.textContent.trim();
      const price = parseFloat(priceText.replace(/[^0-9,.-]+/g, '').replace(',', '.'));
      fwLog('Aktueller Produktpreis:', price);
      return price;
    } else {
      fwLog('Fehler: Kein Preiselement gefunden.');
      return null;
    }
  }

  function updateCartInventoryCache(cartItems) {
    const inventoryMap = cartItems.reduce((acc, item) => {
      acc[item.variant_id] = (acc[item.variant_id] || 0) + item.quantity;
      return acc;
    }, {});
  
    localStorage.setItem('fwCartInventory', JSON.stringify(inventoryMap));
  }

  function checkCartQuantity(type) {
    fwLog('Überprüfe die Menge der Variante im Warenkorb...');
  
    const addToCartButton = document.querySelector('#fwPDPMainBuyBtn');
    if (type === 'Load' && addToCartButton && addToCartButton.disabled) {
      fwLog('Button ist bereits deaktiviert. Keine weiteren Prüfungen notwendig.');
      return;
    }
  
    const currentVariantId = document.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
    if (!currentVariantId) {
      fwLog('Keine Variant-ID gefunden.');
      return;
    }
  
    let maxOrderQuantity = window.maxOrderQuantity || 10;
  
    // Prüfen, ob Bestand kleiner als erlaubte maxOrderQuantity ist
    const inventoryScript = Array.from(document.querySelectorAll('script[type="application/json"]'))
      .find(s => s.textContent.includes('"inventory_quantity"'));
  
    if (inventoryScript) {
      try {
        const inventoryData = JSON.parse(inventoryScript.textContent);
        const variantInventory = inventoryData.find(v => String(v.id) === currentVariantId);
        if (variantInventory && variantInventory.inventory_quantity < maxOrderQuantity) {
          maxOrderQuantity = variantInventory.inventory_quantity;
          fwLog('Bestand ist geringer als maxOrderQuantity. Neuer maxOrderQuantity:', maxOrderQuantity);
        }
      } catch (e) {
        fwLog('Fehler beim Parsen des Bestands-Skripts:', e);
      }
    }
  
    fetch('/cart.js')
      .then(res => {
        if (!res.ok) throw new Error('Fehler beim Abrufen des Warenkorbs: ' + res.status);
        return res.json();
      })
      .then(cart => {
        updateCartInventoryCache(cart.items);
  
        let totalQuantity = 0;
        cart.items.forEach(item => {
          if (String(item.variant_id) === currentVariantId) {
            totalQuantity += item.quantity;
          }
        });
  
        fwLog('Variante bereits im Warenkorb:', totalQuantity);
  
        const remainingQuantity = maxOrderQuantity - totalQuantity;
        fwLog('Verbleibende Menge für die Variante:', remainingQuantity);
  
        const quantityInput = document.querySelector('input[name="quantity"]');
        if (quantityInput) {
          quantityInput.max = remainingQuantity > 0 ? remainingQuantity : 0;
          quantityInput.value = quantityInput.min;
          fwLog('Input max gesetzt:', quantityInput.max);
        }
  
        if (addToCartButton) {
          const productPrice = getProductPrice();
          if (remainingQuantity <= 0 || productPrice === 0) {
            addToCartButton.disabled = true;
            addToCartButton.classList.add('disabled');
            addToCartButton.textContent = productPrice === 0 ? 'Nicht verfügbar' : 'Maximum erreicht';
          } else {
            addToCartButton.disabled = false;
            addToCartButton.classList.remove('disabled');
            addToCartButton.textContent = 'In den Warenkorb';
          }
        }
      })
      .catch(error => {
        fwLog('Fehler beim Abrufen des Warenkorbs:', error);
      });
  }
  




////////// Überwache alle `fetch`-Anfragen, insbesondere `/cart/change` ///////////////////

  (function () {
    const originalFetch = window.fetch;
    window.fetch = function () {
      const fetchArgs = arguments;
      const url = fetchArgs[0];

      // Überwachung von Warenkorbänderungen
      if (typeof url === 'string' && (url.includes('/cart/change') || url.includes('/cart/add') || url.includes('/cart/update'))) {
        fwLog('Fetch für `/cart`-Aktion erkannt - Überprüfung der Produkte wird durchgeführt');
        setTimeout(() => {
          checkCartQuantity('CartChange');
        }, 500); // Kleiner Timeout, um sicherzustellen, dass der Warenkorb aktualisiert wurde
      }

      // Überwachung von Variantenänderungen
/*       if (typeof url === 'string' && url.includes('/variants/') && url.includes('section_id=pickup-availability')) {
        fwLog('Fetch für `/variants`-Aktion erkannt - Überprüfung der Produkte wird durchgeführt');
        setTimeout(() => {
          checkCartQuantity('VariantChange');
        }, 500); // Kleiner Timeout, um sicherzustellen, dass die Produkte vollständig geladen sind
      } */


      // Falls es ein `/cart/add` Request ist, das Cross-Selling-Modal einblenden
      if (typeof url === 'string' && url.includes('/cart/add')) {
        let quantity = '1';
        try {
          const options = fetchArgs[1] || {};
          if (options.body) {
            const formData = new URLSearchParams(options.body);
            quantity = formData.get('quantity') || '1';
            fwLog(`Cross-Sell Menge erkannt: ${quantity}`);
          } else {
            fwLog('Keine Body-Daten im /cart/add Request');
          }
        } catch (err) {
          fwLog('Fehler beim Lesen der Menge: ' + err.message);
        }
  
        setTimeout(() => {
          const overlay = document.getElementById('fwCrosssellModal-overlay');
          const modal = document.getElementById('fwCrosssellModal');
  
          if (overlay && modal) {
            overlay.classList.add('show');
            modal.classList.add('show');
            fwLog('Cross-Selling Modal wurde eingeblendet');
  
            const inputs = modal.querySelectorAll('input[name="quantity"]');
            fwLog(`Inputs im Modal gefunden: ${inputs.length}`);
  
            inputs.forEach(input => {
              input.value = quantity;
              fwLog(`Input gesetzt: ${quantity}`);
            });
          } else {
            fwLog('Modal oder Overlay nicht gefunden');
          }
        }, 500);
      }


      //fwLog('Originaler Fetch wird ausgeführt:', fetchArgs);

      return originalFetch.apply(this, arguments);
    };
  })();

    ////////// Initiale Überprüfung beim Laden der Seite ///////////////////

    checkCartQuantity('Load');

});



